import { __assign } from "tslib";
import { requestWithAuthAndRetry } from '../requestWithAuthAndRetry';
import { requestWithOfficeContext } from '../requestWithOfficeContext';
// eslint-disable-next-line max-params
export function httpPost(eventName, // Your custom event name.
otelEventName, url, // The request url.
data, // Request body. Overrides requestConfig value.
requestConfig, // Optionally allows supplying headers, request body, and Response Type.
jwtAuthEnabled, // Whether jwt auth is enabled for the session. Should come from OfficeComponentContext.
getAccessToken, // Callback to fetch a token. Should come from OfficeComponentContext.
officeHomeApiRoot, // OfficeHome service api root. Should come from OfficeComponentContext.
officeCorrelationId, // Office correlation id. Should come from OfficeComponentContext.
tokenConsumer, // Token (enum value) required for this api.
xhrOptions, // Optional lesser used arguments. Most commonly used to add properties to generated instrumentation events.
strategy, // Legacy argument used to leverage Service Worker cache. Office-start services should be passing NetworkOnly and leverage React Query and simple-persistence library for caching.
scope) {
    if (xhrOptions === void 0) { xhrOptions = {}; }
    var fromCache = strategy === "cache-only" /* FetchStrategy.CacheOnly */;
    // If cached data is requested then no token is needed
    if (fromCache) {
        tokenConsumer = 'None';
    }
    var contextualConfig = __assign(__assign({}, requestConfig), { url: url, method: "POST" /* HttpRequestMethod.Post */, body: data });
    return requestWithAuthAndRetry(function (httpRequestOptions) {
        return requestWithOfficeContext(eventName, otelEventName, httpRequestOptions, officeHomeApiRoot, officeCorrelationId, strategy, xhrOptions.populateRequestEvent, xhrOptions.onUploadProgress, xhrOptions.onDownloadProgress, xhrOptions.cancellationToken, xhrOptions.timeoutInMs);
    }, eventName, otelEventName, contextualConfig, jwtAuthEnabled, getAccessToken, tokenConsumer, xhrOptions.mockParam, xhrOptions.resourceUrl, xhrOptions.rpsHeaderPrefix, xhrOptions.additionalAuthErrors, xhrOptions.isRetriableError, xhrOptions.updateRequestWithAuth, fromCache, undefined, undefined, scope);
}
//# sourceMappingURL=httpPost.js.map